export const CLEANUP_HOME_PAGE_STATE = 'cleanup-home-page-state';
const cleanupHomePageState = () => ({ type: CLEANUP_HOME_PAGE_STATE });
export default cleanupHomePageState;
